import SocialVk from "./vk/SocialVk";

function Social() {
  return <SocialVk />;
}

export default Social;
